// extracted by mini-css-extract-plugin
export var actionButton = "_io-t";
export var buttonContainer = "_io-0";
export var buttonContainer2 = "_io-1";
export var buttonSection = "_io-2";
export var details = "_io-3";
export var dropdownItem = "_io-5";
export var dropdownItemsContainer = "_io-4";
export var fileInput = "_io-r";
export var headerButton = "_io-6";
export var icon = "_io-7";
export var input = "_io-8";
export var macroListItem = "_io-9";
export var mainContent = "_io-a";
export var microText = "_io-b";
export var modal = "_io-w";
export var optionsButton = "_io-c";
export var paperclip = "_io-s";
export var pillContent = "_io-d";
export var preview = "_io-e";
export var preview2 = "_io-f";
export var quillEditor = "_io-q";
export var selectedMacro = "_io-g";
export var sidebar = "_io-h";
export var sidebarHeader = "_io-j";
export var sidebarList = "_io-i";
export var sidebarListItem = "_io-k";
export var sidebarSearch = "_io-l";
export var snoozeDurationWrapper = "_io-v";
export var statusPillContainer = "_io-m";
export var tagsContainer = "_io-n";
export var unselectedMacro = "_io-o";
export var variable = "_io-u";
export var wrapper = "_io-p";